'use strict';

export class init {
    constructor(opt) {
        this.opt = opt;
        init.enablePhoneMask();
        this.bindHandlers();
    }

    bindHandlers() {
        $(document).on('click', 'button#liqpay-widget-close-btn', function () {
            $('#liqpay_widget_popup_container').remove();
        });

        $('button.donation-btn').off('click').on('click', function () {
            $('.phone_unmasked').val($('.phone').cleanVal());
            $('div.error_message').remove();
            $(this).parents('form').submit();
        });

        $('form.donation-data-from').on('submit', function () {
            let form = $(this);
            init.clearErrors(form);

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: new FormData($(this)[0]),
                processData: false,
                contentType: false,
                async: false,//at MacOs and IOS "window.open(url)" is blocking if it's async call
            }).done(function (data) {
                if (data.success) {
                    form.append(data.iframe);

                    if (data.message === 'modal_open') {
                        $('#unsubscribeDonate').foundation('open');
                    }

                    if (data.message === 'redirect_privat24_pay') {
                        let url = 'https://next.privat24.ua/payments/form/{' +
                            '"token":"eb5e55d5-8b5c-41c8-ab6e-673f9c82c858",' +
                            '"sum":"' + data.amount +
                            '"}'
                        window.open(url);
                    }
                } else {
                    if (typeof data.errors !== 'undefined') {

                        let formErrors = typeof data.errors.onceDonationForm === 'undefined'
                            ? data.errors.monthDonationForm : data.errors.onceDonationForm;
                        init.showErrors(formErrors);
                    } else if (data.custom_error !== 'undefined') {
                        console.error(data.custom_error);
                    }
                }
            });

            return false;
        });
    }

    static enablePhoneMask() {
        let mask = '+38(000) 000-0000';
        $('.phone').mask(mask, {placeholder: mask});
    }

    static showErrors(formErrors) {
        $.each(formErrors, function (field, messages) {
            let message = messages.join("\r\n");
            let el = $('.' + field);

            el.addClass('error');
            $('<div class="error_message">' + message + '</div>').insertAfter(el);
        });
    }

    static clearErrors(form) {
        form.find('.error').removeClass('error');
    }
}